import type { Initiative, InitiativeStatus, Metric } from '../initiative-client/initiative-client.type';
import type { Outcome } from '../strategy-client/strategy-client.type';
import type { Epic } from '../tasks-client/task-client.type';

enum MilestoneState {
  COMPLETED = 'completed',
  IN_PROGRESS = 'in_progress',
  NOT_STARTED = 'not_started',
  PAST_DUE = 'past_due',
  UNKNOWN = 'unknown',
}

type MilestonePayload = {
  id?: string;
  name: string;
  description: string | null;
  organization: string;
  target_end_date: string;
  outcome: string;
  epics: string[];
};

type Milestone = {
  id: string;
  name: string;
  description: string | null;
  state: MilestoneState;
  status: InitiativeStatus;
  organization: string;
  target_end_date: string;
  activity_start_date: string;
  activity_end_date: string;
  outcome: Outcome;
  initiative?: Initiative;
  epics: Epic[];
  percent_progress: number;
  completed_subtasks_over_time: Metric;
  total_subtasks_over_time: Metric;
};

export { MilestoneState };
export type { Milestone, MilestonePayload };
